<template>
  <div class="login">
    <el-tabs
      class="tabs"
      v-model="activeTabName"
      stretch>
      <el-tab-pane name="scancode">
        <span slot="label">扫码登录</span>
        <div class="tab_pane scancode">
          <el-image v-loading="qrCodeLoading" class="code_img" :src="qrCodeBase64"></el-image>
          <h1>请使用微信扫码登录</h1>
          <p>若没有账号微信扫码后可直接拥有账号，无需注册</p>
        </div>
      </el-tab-pane>
      <el-tab-pane name="account">
        <span slot="label" class="">账号登录</span>
        <div class="tab_pane account">
          <div class="form_wrapper">
            <el-form
              class="form"
              :model="loginForm"
              :rules="loginRules"
              ref="loginForm"
              size="small">
              <el-form-item class="form_item" prop="mobile">
                <el-input
                  type="text"
                  :maxlength="11"
                  v-model.trim="loginForm.mobile"
                  size="small"
                  placeholder="请输入手机号">
                </el-input>
              </el-form-item>
              <div @keyup.enter="loginBefore">
                <el-form-item class="form_item" prop="password">
                  <el-input
                    type="password"
                    v-model.trim="loginForm.password"
                    size="small"
                    placeholder="请输入密码">
                  </el-input>
                </el-form-item>
              </div>
            </el-form>
            <div class="flex flex_direction login_btn">
              <el-button type="primary" size="small" :loading="loginBtnLoading" @click="loginBefore">登 录</el-button>
            </div>
            <div class="flex justify_between text_size_12 text_line_height_30">
              <span class="text_hover_light_primary" @click="register">注册</span>
              <span class="text_hover_light_primary" @click="resetPassword">忘记密码</span>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as api from '~/api'
import cookie from '~/utils/cookie'
import SHA256 from 'crypto-js/sha256'
export default {
  data () {
    return {
      // 获取二维码loading
      qrCodeLoading: false,
      // 二维码base64
      qrCodeBase64: '',
      // 二维码唯一标识 轮询用
      qrCodeScene: '',
      // 二维码五分钟失效 记录住获取到二维码时的事件
      getQrCodeTime: '',
      // 定时器
      askInterval: null,
      // 当前所激活的tabName
      activeTabName: 'scancode',
      // 登陆的buttonLoading
      loginBtnLoading: false,
      // 登录信息
      loginForm: {
        // 目前为手机号
        mobile: '',
        // 密码
        password: ''
      },
      // 登录表单验证规则
      loginRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}$/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 获取登录二维码
    this.getLoginQrcode()
  },
  methods: {
    // 获取登录微信公众号二维码信息
    getLoginQrcode () {
      this.qrCodeLoading = true
      api.getLoginQrcode().then(res => {
        if (res.data.code === 0) {
          console.log('获取登录二维码', res.data.data)
          this.qrCodeBase64 = res.data.data.src
          this.qrCodeScene = res.data.data.scene
          this.getQrCodeTime = new Date().getTime()

          this.askInterval && clearInterval(this.askInterval)
          // 就算接口在弹窗关闭后调用 如果判断弹窗已经关闭 则不进行轮询
          if (this.$parent && this.$parent.visible) {
            this.askInterval = setInterval(() => {
              // 查询扫描状态
              this.askLogin()
            }, 1000)
          }
        } else {
          this.$message.error(res.data.message)
        }
        this.qrCodeLoading = false
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
        this.qrCodeLoading = false
      })
    },
    // 轮询获取二维码扫描信息
    askLogin () {
      if (this.activeTabName === 'account') {
        return
      }
      api.askLogin(this.qrCodeScene).then(res => {
        if (res.data.code === 0) {
          console.log('轮询获取扫描结果', res.data.data)
          let status = res.data.data.status
          if (status === 'waiting') {
            let curDate = new Date().getTime()
            let overTime = (curDate - this.getQrCodeTime) / 1000
            // 间隔了五分钟的话，重新获取二维码
            if (Math.abs(overTime) > 300) {
              clearInterval(this.askInterval)
              this.getLoginQrcode()
            }
          } else if (status === 'done') {
            // 清除定时器
            clearInterval(this.askInterval)

            // 当前路由完整路径
            let fullPath = this.$route.fullPath
            if (fullPath === '/home?login=1') {
              // 重置地址栏 不然用户点击浏览器的返回按钮会再次弹出登录框
              history.replaceState(null, '', '/home')
            }
            // 设置用户信息
            this.$store.commit('SET_USER_INFO', res.data.data.userInfo)
            // 存储token
            cookie.set('T_j_web_token', res.data.data.token)

            // 未绑定 切换至绑定的弹窗
            if (res.data.data.bind === 0) {
              this.$emit('changeView', 'bindForm')
            } else {
              // 已经绑定过了 关闭弹窗
              this.$emit('closeDialog')
              // 发送登录成功的消息
              this.$bus.emit('loginSuccess')
            }
          }
        } else {
          clearInterval(this.askInterval)
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        clearInterval(this.askInterval)
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
      })
    },

    // 登录前进行验证
    loginBefore () {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          // 调用api登录
          this.login()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 调用api进行登录
    login () {
      this.loginBtnLoading = true
      api.login({
        account: this.loginForm.mobile,
        password: SHA256(this.loginForm.password).toString()
      }).then(res => {
        if (res.data.code === 0) {
          console.log('登录信息', res.data.data)
          // 当前路由完整路径
          let fullPath = this.$route.fullPath
          if (fullPath === '/home?login=1') {
            // 重置地址栏 不然用户点击浏览器的返回按钮会再次弹出登录框
            history.replaceState(null, '', '/home')
          }
          // 设置用户信息
          this.$store.commit('SET_USER_INFO', res.data.data.userInfo)
          // 存储token
          cookie.set('T_j_web_token', res.data.data.token)
          // 未绑定微信号切换至绑定的弹窗
          if (res.data.data.userInfo.subscrib === 0) {
            this.$emit('changeView', 'bindWechat')
          } else {
            // 已经绑定过了 关闭弹窗
            this.$emit('closeDialog')
            // 发送登录成功的消息
            this.$bus.emit('loginSuccess')
          }
        } else {
          this.$message.error(res.data.message)
          console.log(res)
        }
        this.loginBtnLoading = false
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
        this.loginBtnLoading = false
      })
    },

    // 重置表单 (让父组件关闭的时候重置此表单)
    resetForm () {
      this.$refs['loginForm'].resetFields()
    },

    // 忘记密码
    resetPassword () {
      this.$emit('changeView', 'resetpwdForm')
    },
    // 去注册
    register () {
      this.$emit('changeView', 'registerForm')
    },

    // dialog 打开
    openedDialogCallback () {

    },
    // 关闭
    closeDialogCallback () {
      this.askInterval && clearInterval(this.askInterval)
      console.log('关闭了')
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    width: 100%;
    .tabs {
      .tab_pane {
        width: 100%;
        height: 272px;
        &.scancode {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 15px;
          height: 336px;
          .code_img {
            width: 210px;
            height: 210px;
          }
          & > h1 {
            margin-top: 20px;
            margin-bottom: 6px;
            color: #000000;
            font-weight:bold;
            font-size: 16px;
          }
          & > p {
            font-size: 12px;
            color: #000000;
          }
        }
        &.account {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 25px;
          .form_wrapper {
            width: 240px;
            .login_btn {
              margin-top: 32px;
            }
          }
        }
      }
    }
  }

</style>

<style lang="scss">
  .login {
    .el-tabs__nav.is-top.is-stretch {
      justify-content: center;
      .el-tabs__active-bar.is-top {
        display: none;
      }
      .el-tabs__item {
        flex: 0;
        height: 50px;
        line-height: 50px;
        padding: 0;
        &.is-active {
          & > span {
            position: relative;
            &::after {
              content: "";
              position: absolute;
              bottom: -17px;
              left: 0;
              width: 100%;
              height: 2px;
              background-color: #0FA4B3;
            }
          }
        }
        &+.el-tabs__item {
          margin-left: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/form-dialog/login-form.vue